import React from "react"
import Header from "../components/Header"
import Helmet from "react-helmet"
import ColorFinder from "../components/colorfinder/ColorFinder"

function ColorFinderPage() {
  return (
    <div>
      <Helmet>
        <title>Color Finder | Design Resources</title>
        <body className="blackbg" />
      </Helmet>
      <Header title="Color Finder" link="/colorfinder/" />
      <ColorFinder />
    </div>
  )
}

export default ColorFinderPage



// WEBPACK FOOTER //
// ./src/pages/colorfinder.js